module.exports = __webpack_public_path__ + "static/media/ujwal_kitchloo.9df4b31e.png";